import { render, staticRenderFns } from "./Match.vue?vue&type=template&id=de612afc&scoped=true&"
import script from "./Match.vue?vue&type=script&lang=js&"
export * from "./Match.vue?vue&type=script&lang=js&"
import style0 from "./Match.vue?vue&type=style&index=0&id=de612afc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de612afc",
  null
  
)

export default component.exports